module.exports = __webpack_public_path__ + "static/img/head_title.55ba2d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head_title.png
// module id = 7IEp
// module chunks = 1